import { useState, useEffect } from "react";
import { connect } from "react-redux";
import UiButton from "../../Common/UiButton/UiButton";
import "./Style.css";
import { Col, Row } from "react-bootstrap";
import TextInput from "../../Common/UITextInput/TextInput";
import { Form, Drawer, message, notification, Spin, Radio } from "antd";
import UiDropDown from "../../Common/UiDropDown/UiDropDown";
import { LoadingOutlined } from "@ant-design/icons";
import {
  getAllUserByRoleRm,
  savePartnerDetails,
  verifypan,
} from "../../../redux/PartnerActions/actions";
import { getLocation } from "../../../redux/Location/actions";
import {
  getFunction,
  getProductType,
  getPartnerType,
  getAllType,
} from "../../../redux/Masters/actions";
import { Checkbox } from "antd";
import useSession from "../../CustomLogout/useSession";
import { getSVMList } from "../../../redux/BranchDetails/branchLocationAction";

const AddPartner = ({ setPartnerRefresh, ...props }) => {
  const handleSessionExpired = useSession();
  const [btnDisable, setBtnDisable] = useState(false);
  const { access_token } = props;
  const [form] = Form.useForm();
  const FormItem = Form.Item;

  const [partnerTypeId, setPartnerTypeId] = useState([]);
  const [functionTypeId, setFunctionTypeId] = useState([]);
  const [productTypeId, setProductTypeId] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [rmList, setRmList] = useState([]);
  const [roleDataSelect, setRoleDataSelect] = useState([]);
  const [productDataSelect, setProductDataSelect] = useState([]);
  const [panVer, setPanver] = useState(false);
  const [responseId, setResponseId] = useState("");
  const [panData, setPanData] = useState("");
  const [panLoading, setPanLoading] = useState(false);
  const [partnerType, setPartnerType] = useState([]);
  const [partnerCategory, setPartnerCategory] = useState("Application");

  useEffect(() => {
    getCities();
    getAllList();
    getRMUserList();
    getPartnerTypeList();
    // getProduct();
    // getFunctionList();
    // getPartnerList();
  }, []);

  const getPartnerTypeList = () => {
    props
      .getPartnerTypeData({
        access_token,
        url: "ByName",
        name: "PARTNER_CATEGORY",
      })
      .then((res) => {
        if (res) {
          if (res && res.data?.dtoList?.length && res.status === 200) {
            const values = [];
            res &&
              res?.data?.dtoList?.map((item) => {
                values.push({
                  value: item?.serialId,
                  label: item?.value,
                });
                setPartnerType(values);
              });
          }
          if (res?.data?.error || res.message) {
            const errorCode = res?.data?.error?.errorCode || res.errorCode;
            const errorMessage = res?.data?.error?.message || res.message;

            if (errorCode === "403" && res?.data?.error?.logoutStatus) {
              handleSessionExpired();
            } else {
              notification.error({
                description: errorMessage,
                duration: 5,
                placement: "top",
              });
            }
          }
        }
      });
  };

  const getAllList = () => {
    props
      .getAllType({
        access_token,
      })
      .then((res) => {
        // message.loading("Please Wait...", 5);
        if (res) {
          if (res && res.status === 200) {
            let functionListObj = [];
            let productListObj = [];
            let partnerListObj = [];
            if (res.data && res.data.partnerFunctionMasterList) {
              res.data &&
                res.data.partnerFunctionMasterList.map((item) => {
                  const values = {
                    label: item.partnerFunctionName,
                    value: item.partnerFunctionId,
                  };
                  functionListObj.push(values);
                });
              setFunctionTypeId(functionListObj);
            }
            if (res.data && res.data.partnerProductMasterList) {
              res.data &&
                res.data.partnerProductMasterList.map((item) => {
                  const values = {
                    label: item.productName,
                    value: item.productId,
                  };
                  productListObj.push(values);
                });
              setProductTypeId(productListObj);
            }
            if (res.data && res.data.partnerTypeMasterList) {
              res.data &&
                res.data.partnerTypeMasterList.map((item) => {
                  const values = {
                    label: item.partnerTypeName,
                    value: item.partnerTypeId,
                  };
                  partnerListObj.push(values);
                });
              setPartnerTypeId(partnerListObj);
            }
          }
          if (res?.data?.error || res.message) {
            const errorCode = res?.data?.error?.errorCode || res.errorCode;
            const errorMessage = res?.data?.error?.message || res.message;

            if (errorCode === "403" && res?.data?.error?.logoutStatus) {
              handleSessionExpired();
            } else {
              notification.error({
                description: errorMessage,
                duration: 5,
                placement: "top",
              });
            }
          }
        }
      });
  };

  const getCities = () => {
    props
      .getLocation({
        access_token,
        url: "Cities",
      })
      .then((res) => {
        // message.loading("Please Wait...", 5);
        if (res) {
          if (res && res.status === 200) {
            let cityListObj = [];
            res.data &&
              res.data.dtoList.map((item) => {
                const values = {
                  label: item.cityName,
                  value: item.cityId,
                };
                cityListObj.push(values);
              });
            setCityList(cityListObj);
          }
          if (res?.data?.error || res.message) {
            const errorCode = res?.data?.error?.errorCode || res.errorCode;
            const errorMessage = res?.data?.error?.message || res.message;

            if (errorCode === "403" && res?.data?.error?.logoutStatus) {
              handleSessionExpired();
            } else {
              notification.error({
                description: errorMessage,
                duration: 5,
                placement: "top",
              });
            }
          }
        }
      });
  };

  const getRMUserList = () => {
    props
      .getAllUserByRoleRm({
        access_token,
      })
      .then((res) => {
        if (res) {
          if (res && res.status === 200) {
            let rmListObj = [];
            // res.data &&
            res.data.rmUserRole.map((item) => {
              const values = {
                label: item.fullName,
                value: item.userId,
              };
              rmListObj.push(values);
            });
            setRmList(rmListObj);
          }
          if (res?.data?.error || res.message) {
            const errorCode = res?.data?.error?.errorCode || res.errorCode;
            const errorMessage = res?.data?.error?.message || res.message;

            if (errorCode === "403" && res?.data?.error?.logoutStatus) {
              handleSessionExpired();
            } else {
              notification.error({
                description: errorMessage,
                duration: 5,
                placement: "top",
              });
            }
          }
        }
      });
  };

  const handleRolechanges = (e) => {
    setRoleDataSelect(e.target.Checked);
  };
  const handleProductchanges = (e) => {
    setProductDataSelect(e.target.Checked);
  };
  const [open, setOpen] = useState(false);
  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
    form.resetFields();
  };

  const AddPartnerHandler = (data) => {
    const values = {
      partnerFirmName: data.PartnerCompanyName,
      cityId: data.City.value,
      partnerTypeIds: data.engagement,
      functionTypeIds: data.role,
      productTypeIds: data.productType,
      // leadCountAllowedBeforeRegistration: data.leadCountBeforeActivation,
      leadTresholdAllowedBeforeRegistration: +data.leadCountBeforeActivation,
      assignedRmUserId: data.assignRM.value,
      signatoryEmail: data.signatoryEmail,
      signatoryFirstName: data.signatoryFirstName?.trim(),
      signatoryLastName: data.signatoryLastName?.trim(),
      signatoryMobile: data.signatoryMobileNumber,
      partnerFirmPanNo: data?.PartnerCompanyPan,
      isPanMatchedWithName: panData?.result?.name == data.PartnerCompanyName,
      partnerFirmPanVerifiedFlag: panVer,
      partnerFirmPanResponseId: responseId,
      partnerCategoryIds: data?.partnerType?.value,
      qualifiedPartner: data?.partnerCategory,
      // userdetails: {
      //   signatoryEmail: data.signatoryEmail,
      //   signatoryFirstName: data.signatoryFirstName,
      //   signatoryLastName: data.signatoryLastName,
      //   signatoryMobile: data.signatoryMobileNumber
      // }
    };

    try {
      setBtnDisable(true);
      props
        .savePartnerDetails({
          values,
          access_token,
        })
        .then((res) => {
          if (res && res.status === 200) {
            message.destroy();
            message.success("Partner Info Save Successfully");
            setBtnDisable(false);
            form.resetFields();
            setPanver(false);
            onClose();
            setTimeout(() => {
              setPartnerRefresh(true);
            }, 1000);
          }
          if (res?.data?.error || res.message) {
            const errorCode = res?.data?.error?.errorCode || res.errorCode;
            const errorMessage = res?.data?.error?.message || res.message;
            setBtnDisable(false);
            if (errorCode === "403" && res?.data?.error?.logoutStatus) {
              handleSessionExpired();
            } else {
              notification.error({
                description: errorMessage,
                duration: 5,
                placement: "top",
              });
            }
          }
        });
    } catch (error) {
      notification.error({
        description: error?.message || "An unexpected error occurred.",
        duration: 5,
        placement: "top",
      });
    } finally {
      setBtnDisable(false);
    }
  };

  const verifypan = () => {
    setPanLoading(true);

    let values = {
      partnerFirmPanNo: form.getFieldValue("PartnerCompanyPan") || null,
      partnerFirmName: form.getFieldValue("PartnerCompanyName") || null,
    };

    props
      .verifypan({
        values,
        access_token,
      })
      .then((res) => {
        if (res && res.status === 200) {
          setPanLoading(false);
          message.destroy();
          message.success("Pan Info Save Successfully");
          setPanver(true);
          setPanData(JSON.parse(res?.data?.dto?.response));
          setResponseId(res?.data?.dto?.karzaLogId);
        }
        if (res?.data?.error || res.message) {
          const errorCode = res?.data?.error?.errorCode || res.errorCode;
          const errorMessage = res?.data?.error?.message || res.message;
          setPanLoading(false);

          if (errorCode === "403" && res?.data?.error?.logoutStatus) {
            handleSessionExpired();
          } else {
            setPanLoading(false);
            notification.error({
              description: errorMessage,
              duration: 5,
              placement: "top",
            });
          }
        }
      });
  };

  const EditChange = () => {
    form.setFieldsValue({
      PartnerCompanyPan: "",
      PartnerCompanyName: "",
    });
    setPanver(false);
  };

  return (
    <div className="addpartner-section">
      {props?.state?.userData?.loggedInRoleType === "RM" && (
        <UiButton title="Add Partner" onClick={showDrawer} />
      )}

      <Drawer
        title="Basic Drawer"
        placement="right"
        onClose={onClose}
        open={open}
        className="add-partner-dow"
      >
        <Form
          autoComplete="off"
          form={form}
          className="addPartner-section-man"
          onFinish={AddPartnerHandler}
        >
          <Row>
            <Col
              lg={12}
              xs={12}
              md={12}
              sm={12}
              className="add-content-partner"
            >
              <Col md={6} className="addpartnerheading">
                <h2 className="main-heading">Add New Partner</h2>
                <div className="headre-line"></div>
              </Col>
              <Col md={6} className="btn-section add-mob-sec">
                <h2 onClick={onClose} className="cancel-btn-add">
                  CANCEL
                </h2>
                {/* <UiButton type="submit" title="Create Partner" /> */}
              </Col>
            </Col>
          </Row>
          <h3 className="sub-text">Firm info</h3>
          <Row>
            <Col
              lg={12}
              xs={12}
              md={12}
              sm={12}
              className="add-fields-partner add__partner__company__name"
            >
              <Col md={8} style={{ width: "65%" }}>
                <FormItem
                  name="PartnerCompanyName"
                  label="Partner Company Name"
                  colon={false}
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Partner Company Name",
                    },
                  ]}
                >
                  <TextInput
                    maxLength={100}
                    disabled={panVer || panLoading}
                    onInput={(e) => {
                      let inputValue = e.target.value;
                      inputValue = inputValue.replace(/[^A-Za-z0-9 ]/g, "");
                      inputValue = inputValue.toUpperCase().trimStart();
                      e.target.value = inputValue;
                    }}
                    type="text"
                  />
                </FormItem>
              </Col>
              <Col md={4} className="add-partner-sec-2 mob-sec-cit-ad">
                <FormItem
                  name="City"
                  label="City"
                  colon={false}
                  rules={[
                    {
                      required: true,
                      message: "Please select city name",
                    },
                  ]}
                >
                  <UiDropDown
                    placeholder="Select"
                    data={cityList}
                    className="partner"
                  />
                </FormItem>
              </Col>
            </Col>
          </Row>

          <Row>
            <Col className="panverify" md={8}>
              <FormItem
                name="PartnerCompanyPan"
                label="Partner Company Pan"
                colon={false}
                rules={[
                  {
                    required: true,
                    message: "Please Enter Pan details",
                  },
                ]}
              >
                <TextInput
                  maxLength={10}
                  disabled={panVer || panLoading}
                  onInput={(e) => {
                    if (e.target.value.trim() == "") {
                      e.target.value = e.target.value.trim();
                    }

                    if (e.target.value.trim() !== "") {
                      e.target.value = e.target.value.trimStart().toUpperCase();
                    }
                  }}
                  type="text"
                />
              </FormItem>
            </Col>
            <Col
              md={3}
              className="panverifybtn"
              style={{ display: "flex", alignItems: "center" }}
            >
              {panVer ? (
                <UiButton type="button" title="change" onClick={EditChange} />
              ) : (
                <UiButton
                  type={"button"}
                  className="verifypanbtn"
                  title="verify & check"
                  disable={panLoading}
                  onClick={verifypan}
                />
              )}
              {panLoading && (
                <Spin
                  size="large"
                  className="pr-4"
                  indicator={<LoadingOutlined style={{ color: "#00d8db" }} />}
                ></Spin>
              )}
            </Col>
          </Row>

          <Row>
            <Col lg={12} xs={12} md={12} sm={12} className="add-fields-partner">
              <Col md={12} className="add-partner-checkbox mob-chk-d">
                <FormItem
                  className="mob-chk-d"
                  name="engagement"
                  label="Engagement (Multi Select)"
                  colon={false}
                  rules={[
                    {
                      required: true,
                      message: "Please Select Engagement",
                    },
                  ]}
                >
                  <Checkbox.Group options={partnerTypeId} />
                </FormItem>
              </Col>
            </Col>
          </Row>

          <Row>
            <Col
              lg={12}
              xs={12}
              md={12}
              sm={12}
              className="add-fields-partner "
            >
              <Col
                md={12}
                style={{
                  marginTop: "20px",
                }}
                className="add-partner-checkbox mob-chk-d"
              >
                <FormItem
                  name="role"
                  label="Role (Multi Select)"
                  colon={false}
                  rules={[
                    {
                      required: true,
                      message: "Please Select Role",
                    },
                  ]}
                >
                  <Checkbox.Group
                    options={functionTypeId}
                    onClick={handleRolechanges}
                    value={roleDataSelect}
                  />
                </FormItem>
              </Col>
            </Col>
          </Row>

          <Row>
            <Col md={8} style={{ width: "60%" }}>
              <FormItem
                name="partnerType"
                label="Partner Type"
                className="partner-type-class"
                colon={false}
                rules={[
                  {
                    required: true,
                    message: "Please Select Partner Type",
                  },
                ]}
              >
                <UiDropDown
                  placeholder="Select"
                  data={partnerType}
                  className="partner"
                />
              </FormItem>
            </Col>
          </Row>

          <Row>
            <Col
              lg={12}
              xs={12}
              md={12}
              sm={12}
              className="add-fields-partner partner-category-radio"
            >
              <Col
                md={12}
                style={{ marginTop: "0px" }}
                className="add-partner-checkbox"
              >
                <FormItem
                  name="partnerCategory"
                  label="Partner Category"
                  colon={false}
                  rules={[
                    {
                      required: true,
                      message: "Please select partner category",
                    },
                  ]}
                >
                  <Radio.Group
                    value={partnerCategory}
                    onChange={(e) => setPartnerCategory(e.target.value)}
                    className="partner-category-radio-group"
                  >
                    <Radio value="APPLICATION">APPLICATION</Radio>
                    <Radio value="LEAD">LEAD</Radio>
                    <Radio value="BOTH">BOTH</Radio>
                  </Radio.Group>
                </FormItem>
              </Col>
            </Col>
          </Row>

          <Row>
            <Col lg={12} xs={12} md={12} sm={12} className="add-fields-partner">
              <Col
                md={12}
                style={{ marginTop: "20px" }}
                className="add-partner-checkbox"
              >
                <FormItem
                  name="productType"
                  label="Product Type (Multi Select)"
                  colon={false}
                  rules={[
                    {
                      required: true,
                      message: "Please Select Product Type",
                    },
                  ]}
                >
                  <Checkbox.Group
                    options={productTypeId}
                    onClick={handleProductchanges}
                    value={productDataSelect}
                  />
                </FormItem>
              </Col>
            </Col>
          </Row>

          <h3 style={{ marginTop: "30px" }} className="sub-text">
            Signatory Info
          </h3>
          <Row>
            <Col lg={12} xs={12} md={12} sm={12} className="add-fields-partner">
              <Col md={8} className="mob-sec-sn" style={{ width: "50%" }}>
                <FormItem
                  name="signatoryFirstName"
                  label="Signatory First Name"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Signatory First Name",
                    },
                  ]}
                >
                  <TextInput
                    onInput={(e) => {
                      let inputValue = e.target.value;
                      inputValue = inputValue.replace(/[^A-Za-z ]/g, "");
                      inputValue = inputValue.trimStart();
                      if (inputValue.trim() == "") {
                        inputValue = inputValue.trim();
                      }

                      if (inputValue.trim() !== "") {
                        inputValue = inputValue.trimStart();
                      }
                      e.target.value = inputValue;
                    }}
                    maxLength={75}
                    type="text"
                  />
                </FormItem>
              </Col>
              <Col
                md={4}
                style={{ width: "50%" }}
                className="add-partner-sec-2"
              >
                <FormItem
                  name="signatoryLastName"
                  label="Signatory Last Name"
                  colon={false}
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Signatory Last Name",
                    },
                  ]}
                >
                  <TextInput
                    onInput={(e) => {
                      let inputValue = e.target.value;
                      inputValue = inputValue.replace(/[^A-Za-z ]/g, "");
                      inputValue = inputValue.trimStart();
                      if (inputValue.trim() == "") {
                        inputValue = inputValue.trim();
                      }

                      if (inputValue.trim() !== "") {
                        inputValue = inputValue.trimStart();
                      }
                      e.target.value = inputValue;
                    }}
                    maxLength={75}
                    type="text"
                  />
                </FormItem>
              </Col>
            </Col>
          </Row>
          <Row>
            <Col
              lg={12}
              xs={12}
              md={12}
              sm={12}
              style={{ marginTop: "30px" }}
              className="add-fields-partner mob-sec-sE"
            >
              <Col
                md={8}
                style={{ width: "60%" }}
                className="add__partner__email"
              >
                <FormItem
                  name="signatoryEmail"
                  label="Signatory Email"
                  colon={false}
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Signatory Email",
                    },
                    {
                      pattern:
                        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                      message: "Invalid email format",
                    },
                  ]}
                >
                  <TextInput
                    onInput={(e) => {
                      if (e.target.value.trim() == "") {
                        e.target.value = e.target.value.trim();
                      }

                      if (e.target.value.trim() !== "") {
                        e.target.value = e.target.value.trimStart();
                      }
                    }}
                    maxLength={255}
                    type="email"
                  />
                </FormItem>
              </Col>
              <Col
                md={4}
                style={{ width: "40%" }}
                className="add-partner-sec-2 "
              >
                <FormItem
                  name="signatoryMobileNumber"
                  label="Signatory Mobile Number"
                  colon={false}
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Signatory Mobile Number",
                    },
                    {
                      pattern: /^[6-9][0-9]{9}$/,
                      message: "Please Enter Valid Mobile Number",
                    },
                  ]}
                >
                  <TextInput
                    type="text"
                    maxLength={10}
                    onInput={(e) => {
                      if (e.target.value.trim() == "") {
                        e.target.value = e.target.value.trim();
                      }

                      if (e.target.value.trim() !== "") {
                        e.target.value = new RegExp("^[0-9-+]*$").test(
                          e.target.value
                        )
                          ? e.target.value?.trimStart()
                          : e.target.value
                              ?.trimStart()
                              ?.substring(0, e.target.value.length - 1);
                      }
                    }}
                    // maxLength={10}
                    // type="tel"
                  />
                </FormItem>
              </Col>
            </Col>
          </Row>

          <h3 style={{ marginTop: "40px" }} className="sub-text">
            Configuration Info
          </h3>
          <Row>
            <Col lg={12} xs={12} md={12} sm={12} className="add-fields-partner">
              <Col md={8} style={{ width: "65%" }}>
                <FormItem
                  name="leadCountBeforeActivation"
                  label="Lead Count Before Activation"
                  colon={false}
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Lead Count",
                    },
                  ]}
                >
                  <TextInput
                    type="text"
                    maxLength={2}
                    onInput={(e) => {
                      if (e.target.value.trim() == "") {
                        e.target.value = e.target.value.trim();
                      }

                      if (e.target.value.trim() !== "") {
                        e.target.value = new RegExp("^[0-9-+]*$").test(
                          e.target.value
                        )
                          ? e.target.value?.trimStart()
                          : e.target.value
                              ?.trimStart()
                              ?.substring(0, e.target.value.length - 1);
                      }
                    }}
                  />
                </FormItem>
              </Col>
              <Col md={4} className="add-partner-sec-2 mob-sec-rm-ad">
                <FormItem
                  name="assignRM"
                  label="Assign RM"
                  colon={false}
                  rules={[
                    {
                      required: true,
                      message: "Please Select Assign RM",
                    },
                  ]}
                >
                  <UiDropDown
                    placeholder="Select"
                    data={rmList}
                    className="partner"
                  />
                </FormItem>
              </Col>
            </Col>
          </Row>
          <Row>
            <Col
              lg={12}
              xs={12}
              md={12}
              sm={12}
              style={{ marginTop: "10px" }}
              className="add-fields-partner last-btn-sec-changes"
            >
              <Col md={12} className="btn-section add-mob-sec">
                <UiButton
                  disabled={btnDisable || !panVer}
                  type="submit"
                  title="Create Partner"
                />
              </Col>
            </Col>
          </Row>
        </Form>
        <br />
        <br />
        <br />
      </Drawer>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    savePartnerDetails: (data) => dispatch(savePartnerDetails(data)),
    getLocation: (data) => dispatch(getLocation(data)),
    getFunction: (data) => dispatch(getFunction(data)),
    getProductType: (data) => dispatch(getProductType(data)),
    getPartnerType: (data) => dispatch(getPartnerType(data)),
    getAllType: (data) => dispatch(getAllType(data)),
    getAllUserByRoleRm: (data) => dispatch(getAllUserByRoleRm(data)),
    verifypan: (data) => dispatch(verifypan(data)),
    getPartnerTypeData: (data) => dispatch(getSVMList(data)),
  };
};

const mapStateToProps = (state) => {
  return {
    state: state && state.auth,
    access_token: state && state.auth && state.auth.idToken,
    rmUserList: state && state.partner && state.partner.rmUserList,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddPartner);
